import once from 'lodash/once';
import PrimitiveEE from '../PrimitiveEE';
import TypedEE from '../TypedEE';



export default () => {
  const ee = TypedEE();

  return {
    emit (eventName, ...args) {
      setTimeout(() => {
        ee.emit(eventName, ...args);
      }, 0);
    },

    on (eventName, callback) {
      return ee.on(eventName, callback);
    },

    wrap () {
      let globalEE = this;
      let destroyed = false;
      let destroyEE = PrimitiveEE();
      const ee = {};

      ee.emit = (...args) => {
        if (destroyed) {
          return;
        }

        globalEE.emit(...args);
      };

      ee.on = (...args) => {
        if (destroyed) {
          return () => {};
        }

        const off = globalEE.on(...args);

        destroyEE.on(off);

        return off;
      };

      ee.wrap = () => {
        if (destroyed) {
          return [ ee, () => {} ];
        }

        return globalEE.wrap();
      };

      const off = once(() => {
        destroyed = true;
        destroyEE.emit();
        destroyEE.cleanup();
        destroyEE = null;
        globalEE = null;
      });

      return [ ee, off ];
    }
  };
};



// WEBPACK FOOTER //
// ./src/lib/cmp/EE.js